<button class="twc-button twc-button-link button-previous" *ngIf="isPrevButtonVisible"
    (click)="wizardFooterService.previousClick()" [disabled]="!isPrevButtonEnabled || wizard.isFirstStep">
    {{'WIZARD.PREVIOUS' | translate}}
</button>
<button class="twc-button twc-button-primary button-next" *ngIf="isNextButtonVisible && !wizard.isLastStep"
    (click)="wizardFooterService.nextClick()" [disabled]="!isNextButtonEnabled">
    {{'WIZARD.NEXT' | translate}}
</button>
<button class="twc-button twc-button-primary" *ngIf="isFinishButtonVisible && wizard.isLastStep"
    [disabled]="!isFinishButtonEnabled" (click)="wizardFooterService.finishClick()">
    {{finishButtonText | translate}}
</button>
<button class="twc-button twc-button-primary" *ngIf="isCloseButtonVisible" (click)="wizardFooterService.closeClick()">
    {{'GENERAL.CLOSE' | translate}}
</button>
<button class="twc-button twc-button-primary" *ngIf="isLoadingButtonVisible" disabled>
    <twc-loader size="tiny"></twc-loader>
</button>